/* global imagesData */
import React, { useEffect, useState } from 'react';

import AccessibleCarousel from '../AccessibleCarousel';
import { gettext } from '../../utils/text';
import Image from './Image';

const ImageCarousel = () => {
    const [images, setImages] = useState([]);

    useEffect(() => {
        if (typeof imagesData !== 'undefined' && Array.isArray(imagesData)) {
            setImages(imagesData);
        }
    }, []);

    if (!images.length) {
        return null;
    }

    const slides = images.map((item, index) => ({
        id: index,
        content: <Image {...item} />,
        className: 'gallery-carousel__slide',
        ariaLabel: item.title
            ? `${item.title} (${index + 1}/${images.length})`
            : undefined,
    }));

    return (
        <AccessibleCarousel
            slides={slides}
            ariaLabel={gettext('Restaurant images')}
            showDots={false}
            splideOptions={{
                autoWidth: true,
            }}
            className="gallery-carousel__splide"
        />
    );
};

export default ImageCarousel;
